import { DropdownSelector } from '@repo/design-system-kit/components/dropdown-selector/dropdown-selector';
import { useIntl } from 'react-intl';
import { LOCALES_DEFINITION } from '@repo/shared-config/constants/locales';
import { isLocaleCode, useI18n } from '@repo/runtime-kit/i18n/i18n-provider';
import styles from './dropdown-language.module.css';

interface DropdownLanguageProps {
  className?: string;
  listBoxClassName?: string;
  onLocaleChange?: (newLocale: string) => void;
}

export function DropdownLanguage({
  className,
  listBoxClassName,
  onLocaleChange,
}: DropdownLanguageProps): React.ReactNode {
  const locales = Object.values(LOCALES_DEFINITION).map(({ name, code }) => ({
    key: code,
    label: name,
  }));

  const { formatMessage } = useIntl();
  const { setLocale, isPending, locale } = useI18n();

  const handleSelectionChange = (newLocale: string) => {
    if (newLocale === locale) return;
    if (!isLocaleCode(newLocale)) return;

    setLocale(newLocale);

    onLocaleChange?.(newLocale);
  };

  return (
    <div className={className} data-react-aria-top-layer>
      <DropdownSelector
        aria-label={formatMessage({ id: 'shared-kit.a11y-language-selector' })}
        buttonSize="sm"
        data-test-language-dropdown
        isDisabled={isPending}
        items={locales}
        listBoxClassName={listBoxClassName ?? styles.listBoxContent}
        onSelectionChange={handleSelectionChange}
        selectedKey={locale}
      />
    </div>
  );
}
